export default () => ({
    similar: null,
    related: null,
    recent: null,
    recommended: null,
})
